<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Demographics EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="tglnId"
              disabled
              label="TGLN ID"
            />
          </div> 
          <!-- <div class="col-1 verticalLine"></div> -->
          <div class="col-4">
            <ADSTextInput
              v-model="tglnId"
              disabled
              label="TGLN ID"
            />
          </div> 
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="firstName"
              disabled
              label="First Name"
              :class="{ highlightField: isDifferent(oatsFirstName, firstName) }"
            />
          </div> 
          <!-- <div class="col-1 verticalLine"></div> -->
          <div class="col-4">
            <ADSTextInput
              v-model="oatsFirstName"
              disabled
              label="First Name"
              class="mandatory-field"
            />
          </div> 
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="middleName"
              disabled
              label="Middle Name"
              :class="{ highlightField: isDifferent( oatsMiddleName, middleName ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsMiddleName"
              disabled
              label="Middle Name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="lastName"
              disabled
              label="Last Name"
              :class="{ highlightField: isDifferent(oatsLastName, lastName) }"
            />
          </div> 
          <div class="col-4">
            <ADSTextInput
              v-model="oatsLastName"
              disabled
              label="Last Name"
              class="mandatory-field"
            />
          </div> 
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="birthDate"
              disabled
              label="Date of Birth"
              :class="{ highlightField: isDifferent( oatsBirthDate, birthDate ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsBirthDate"
              disabled
              label="Date of Birth"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="gender"
              disabled
              label="Sex"
              :class="{ highlightField: isDifferent( gender, oatsSex ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsSex"
              disabled
              label="Sex"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <!-- <div class="row">
            <div class="col-3">
              <ADSTextInput
                v-model="isGenderDifferent"
                disabled
                label="Gender is different"
                :class="{ highlightField: isDifferent( isGenderDifferent, oatsIsGenderDifferent ) }"
              />
            </div>
  
            <div class="col-4">
              <ADSTextInput
                v-model="oatsIsGenderDifferent"
                disabled
                label="Gender is different"
              />
            </div>
          </div> -->
  
  
  
        <!-- <div class="row">
            <div class="col-3">
              <ADSTextInput
                v-model="genderDifferent"
                disabled
                label="Gender"
                :class="{ highlightField: isDifferent( genderDifferent, oatsGender ) }"
              />
            </div> 
  
            <div class="col-4">
              <ADSTextInput
                id="disabled-text"
                v-model="oatsGender"
                disabled
                label="Gender"
              />
            </div>
          </div> -->
  
        <!-- <div class="row">
            <div class="col-3">
              <ADSTextInput
                v-model="genderOther"
                disabled
                label="Gender-Other"
                :class="{ highlightField: isDifferent( genderOther, oatsGenderOther ) }"
              />
            </div> 
  
            <div class="col-4">
              <ADSTextInput
                v-model="oatsGenderOther"
                disabled
                label="Gender-Other"
              />
            </div>
          </div> -->
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="insuranceType"
              disabled
              label="Insurance Type"
              :class="{ highlightField: isDifferent( insuranceType, oatsInsuranceType ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsInsuranceType"
              disabled
              label="Insurance Type"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="insuranceNumber"
              disabled
              label="Insurance Number"
              :class="{ highlightField: isDifferent( insuranceNumber, oatsInsuranceNumber ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsInsuranceNumber"
              disabled
              label="Insurance Number"
            />
          </div>
        </div>
  
        <div class="row">
          <div
            v-if="insuranceType === 'OOP'"
            class="col-3"
          >
            <ADSTextInput
              v-model="insuranceProvince"
              disabled
              label="Insurance Province"
              :class="{ highlightField: isDifferent( insuranceProvince, oatsInsuranceProvince ) }"
            />
          </div>
          <div
            v-if="insuranceType !== 'OOP'"
            class="col-3"/>
  
          <div 
            v-if="oatsInsuranceType === 'OOP'"
            class="col-4"
          >
            <ADSTextInput
              id="disabled-text"
              v-model="oatsInsuranceProvince"
              disabled
              label="Insurance Province"
            />
          </div>
        </div>
  
  
        <!-- <div class="row">
            <div class="col-3">
              <ADSTextInput
                v-model="age"
                disabled
                label="Age"
              />
            </div>
  
            <div class="col-4">
              <ADSTextInput
                v-model="oatsAge"
                disabled
                label="Age"
              />
            </div>
          </div> -->
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="address"
              disabled
              label="Address"
              :class="{ highlightField: isDifferent( address, oatsAddress ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsAddress"
              disabled
              label="Address"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="city"
              disabled
              label="City"
              :class="{ highlightField: isDifferent( city, oatsCity ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsCity"
              disabled
              label="City"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="state"
              disabled
              label="Province/State"
              :class="{ highlightField: isDifferent( state, oatsState ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsState"
              disabled
              label="Province/State"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="postalCode"
              disabled
              label="Postal Code"
              :class="{ highlightField: isDifferent( postalCode, oatsPostalCode ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              id="disabled-text"
              v-model="oatsPostalCode"
              disabled
              label="Postal Code"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="country"
              disabled
              label="Country"
              :class="{ highlightField: isDifferent( country, oatsCountry ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsCountry"
              disabled
              label="Country"
              class="mandatory-field"
            />
          </div>
        </div>
  
         
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="mobile"
              disabled
              label="Mobile"
              :class="{ highlightField: isDifferentPhoneNumbers( mobile, oatsMobile ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsMobile"
              disabled
              label="Mobile"
            />
          </div>
        </div>
  
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="homeNumber"
              disabled
              label="Home Number"
              :class="{ highlightField: isDifferentPhoneNumbers( homeNumber, oatsHomeNumber ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsHomeNumber"
              disabled
              label="Home Number"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="email"
              disabled
              label="Email"
              :class="{ highlightField: isDifferent( email, oatsEmail ) }"
              class="Email"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsEmail"
              disabled
              label="Email"
              class="Email"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="ethnicity"
              disabled
              label="Ethnicity"
              :class="{ highlightField: isDifferent( ethnicity, oatsEthnicity ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsEthnicity"
              disabled
              label="Ethnicity"
              class="mandatory-field"
            />
          </div>
        </div>
      
  
        <div class="row">
          <div class="col-3" v-if="ethnicity === 'Other'">
            <ADSTextInput
              id="disabled-text"
              v-model="ethnicityOther"
              disabled
              label="Ethnicity Other"
              :class="{ highlightField: isDifferent( ethnicityOther, oatsEthnicityOther ) }"
            />
          </div>
          <div class="col-3" v-if="ethnicity !== 'Other'">
          </div>
  
          <div class="col-4" v-if="oatsEthnicity === 'Other'">
            <ADSTextInput
              id="disabled-text"
              v-model="oatsEthnicityOther"
              disabled
              label="Ethnicity Other"
            />
          </div>
        </div>
  
        <div
          v-if="patientType === 'Recipient'"
          class="row"
        >
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="rhFactor"
              disabled
              label="RH Factor"
              :class="{ highlightField: isDifferent( rhFactor, oatsRHFactor ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              id="disabled-text"
              v-model="oatsRHFactor"
              disabled
              label="RH Factor"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div
          v-if="patientType === 'Recipient'"
          class="row"
        >
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="bloodType"
              disabled
              label="Blood Type"
              :class="{ highlightField: isDifferent( bloodType, oatsBloodType ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              id="disabled-text"
              v-model="oatsBloodType"
              disabled
              label="Blood Type"
              class="mandatory-field"
            />
          </div>
        </div>
  
        <div
          v-if="patientType === 'Recipient'"
          class="row"
        >
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="bloodTypeVerified"
              disabled
              label="Blood Type Verified"
              :class="{ highlightField: isDifferent( bloodTypeVerified, oatsBloodTypeVerified ) }"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              v-model="oatsBloodTypeVerified"
              disabled
              label="Blood Type Verified"
            />
          </div> 
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import { PATIENT_TYPES } from '@/constants';
  // import { ADSTextInput } from '@afflo/afflo-design-system';
  import _ from 'lodash';
  
  export default {
    name: "DemographicsSectionDetailsDonorEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientType:{
        type: String,
        default: null
      },
      patientBundle: {
        type: Object,
        default: null,
      }
      ,
      patientBundleOATS: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        tglnId : this.getTglnId( this.patient ),
        oatstglnId: this.getOATSTglnID( this.patientBundleOATS ),
        firstName : this.getName( this.patient ).firstName,
        oatsFirstName: this.getOATSFirstName( this.patientBundleOATS ),
        oatsLastName: this.getOATSLastName( this.patientBundleOATS ),
        oatsMiddleName: this.getOATSMiddleName( this.patientBundleOATS ),
        lastName : this.getName( this.patient ).lastName,
        middleName : this.getName( this.patient ).middleName,
        birthDate: this.patient.birthDate,
        oatsBirthDate: this.getOATSBirthDate( this.patientBundleOATS ),
        gender: this.patient.gender,
        oatsSex: this.getOATSSex( this.patientBundleOATS ),
        isGenderDifferent: this.getIsGenderDifferent( this.patientBundle ),
        oatsIsGenderDifferent: this.getOATSIsGenderDifferent( this.patientBundleOATS ),
        oatsGender: this.getOATSGender( this.patientBundleOATS ),
        oatsGenderOther: this.getOATSGenderOther( this.patientBundleOATS ),
        genderDifferent: this.getGenderDifferent( this.patient ),
        genderOther: this.getGenderOther( this.patientBundle ),
        country: this.getCountry( this.patient ),
        oatsCountry: this.getOATSCountry( this.patientBundleOATS ),
        age: this.calculateAge( this.patient.birthDate ),
        oatsAge: this.getOATSAge( this.patientBundleOATS ),
        state: this.patient.address[ 0 ]?.state,
        oatsState: this.getOATSState( this.patientBundleOATS ),
        postalCode: this.patient.address[ 0 ]?.postalCode,
        oatsPostalCode: this.getOATSPostalCode( this.patientBundleOATS ),
        address: this.patient.address[ 0 ]?.line?.[ 0 ],
        oatsAddress: this.getOATSAddress( this.patientBundleOATS ),
        city: this.patient.address[ 0 ]?.city,
        oatsCity: this.getOATSCity( this.patientBundleOATS ),
        mobile: this.getMobile( this.patient ),
        oatsMobile: this.getOATSMobile( this.patientBundleOATS ),
        homeNumber: this.getHomeNumber( this.patient ),
        oatsHomeNumber: this.getOATSHomeNumber( this.patientBundleOATS ),
        email: this.getEmail( this.patient ),
        oatsEmail: this.getOATSEmail( this.patientBundleOATS ),
        pager: this.getPager( this.patient ),
        oatsPager: this.getOATSPager( this.patientBundleOATS ),
        ethnicity: this.getEthnicity( this.patientBundle ),
        oatsEthnicity: this.getOATSEthnicity( this.patientBundleOATS ),
        ethnicityOther: this.getEthnicityOther( this.patientBundle ),
        oatsEthnicityOther: this.getOATSEthnicityOther( this.patientBundleOATS ),
        insuranceType: this.getInsuranceType( this.patientBundle ),
        oatsInsuranceType: this.getOATSInsuranceType( this.patientBundleOATS ),
        insuranceNumber: this.getInsuranceNumber( this.patientBundle ),
        oatsInsuranceNumber: this.getOatsInsuranceNumber( this.patientBundleOATS ),
        insuranceProvince: this.getInsuranceProvince( this.patientBundle ),
        oatsInsuranceProvince: this.getOatsInsuranceProvince( this.patientBundleOATS ),
        className: this.getClassName( this.patientBundle ),
        bloodType: this.getBloodType( this.patientBundle ),
        rhFactor: this.getRHFactor( this.patientBundle ),
        oatsRHFactor: this.getOATSRHFactor( this.patientBundleOATS ),
        oatsBloodType: this.getOATSBloodType( this.patientBundleOATS ),
        bloodTypeVerified: this.getBloodTypeVerified( this.patientBundle ),
        oatsBloodTypeVerified: this.getOATSBloodTypeVerified( this.patientBundleOATS ),
        //cPRA: this.getCPRA( this.patientBundle ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      isDifferent( a, b ) {
        return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
    },
    isDifferentPhoneNumbers( a, b ) {
        const normalize = ( v ) => ( String( v ?? '' ).match( /\d/g ) || [] ).join( '' );
        return normalize( a ) !== normalize( b );
    },
      calculateAge( birthDate ) {
        let age = Math.floor( ( new Date() - new Date( birthDate ) ) / 31536000000 );
        return age?.toString();
      },
      getTglnId( patient ) {
        let identifier_type="TGLNRecipient"; // By default, it was already recipient, so keeping it as that for now.
        switch( this.patientType ){
          case PATIENT_TYPES.DONOR.name:
            identifier_type = "TGLNDonor";
            break;
          case PATIENT_TYPES.RECIPIENT.name:
            identifier_type = "TGLNRecipient";
            break;
        }
        let tglnId = patient.identifier.filter( ( n ) => ( n.use === 'usual' && n.type?.text === identifier_type ) ) ;
        return tglnId[0]?.value ? tglnId[0]?.value : '--' ;
      },
      getOATSTglnID( patientBundleOATS ) {
        return patientBundleOATS?.client_id;
      },
      getName( patient ) {
        let fullName = patient.name.filter( ( n ) => ( n.use === 'official' ) ) ;
        let firstName = '';
        let lastName = '';
        let middleName = '';
        if( fullName[0] && fullName[0].given && fullName[0].family ) {
          lastName = _.get( fullName[0], 'family', '' );
          firstName = _.get( fullName[0], 'given.[0]', '' ); 
          middleName = _.get( fullName[0], 'given.[1]', '' ); 
        }
        let name = { 'firstName': firstName, "lastName": lastName, "middleName": middleName };
        return name;
      },
      getCountry( patient ) {
        if( patient.address[ 0 ]?.country === 'CAN' ) {
          return 'CAN';
        } else if( patient.address[ 0 ]?.country === 'USA' ) {
          return 'USA';
        } else if( patient.address[ 0 ]?.country === 'US' ) {
          return 'USA';
        }
        else if( patient.address[ 0 ]?.country === 'CA' ) {
          return 'CAN';
        } else {
          return patient.address[ 0 ]?.country;
        }
      },
      getOATSFirstName( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.first_name;
      },
      getOATSLastName( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.last_name;
      },
      getOATSMiddleName( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.middle_name;
      },
      getOATSBirthDate( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.birth?.date;
      },
      getOATSSex( patientBundleOATS ) {
        const value = patientBundleOATS?.patient_profile?.sex;
        if( value === 'F' ) {
          return 'Female';
        }
        if( value === 'M' ) {
          return 'Male';
        }
        if( value === 'U' ) {
          return 'Unknown';
        }
        return value;
      },
      getOATSIsGenderDifferent( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.gender_sex_different?.toString();
      },
      getOATSGender( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.gender;
      },
      getOATSGenderOther( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.gender;
      },
      getOATSCountry( patientBundleOATS ) {
        if( _.get( patientBundleOATS, 'patient_profile.addresses[0].country_code' )?.toLowerCase() === 'xx' ) {
        return 'Other';
        } 
        if( _.get( patientBundleOATS, 'patient_profile.addresses[0].country_code' )?.toLowerCase() === 'can' ) {
        return 'CAN';
        }
        if( _.get( patientBundleOATS, 'patient_profile.addresses[0].country_code' )?.toLowerCase() === 'usa' ) {
        return 'USA';
        }
        else {
          return _.get( patientBundleOATS, 'patient_profile.addresses[0].country_code' );
        }
      },
      getOATSAge( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.age;
      },
      getOATSState( patientBundleOATS ) {
        return _.get( patientBundleOATS, 'patient_profile.addresses[0].province_code' );
      },
      getOATSPostalCode( patientBundleOATS ) {
        return _.get( patientBundleOATS, 'patient_profile.addresses[0].postal_code' );
      },
      getOATSAddress( patientBundleOATS ) {
        return _.get( patientBundleOATS, 'patient_profile.addresses[0].street' );
      },
      getOATSCity( patientBundleOATS ) {
        return _.get( patientBundleOATS, 'patient_profile.addresses[0].city' );
      },
      getOATSMobile( patientBundleOATS ) {
        const value = patientBundleOATS?.patient_profile?.contact_details?.phone_mobile;
        if ( value === null || value === undefined ) return value;
        return String( value ).replace( /^\s*(?:\+1)\s*[-.]?\s*/, '' );
      },
      getOATSHomeNumber( patientBundleOATS ) {
        const value = patientBundleOATS?.patient_profile?.contact_details?.phone_primary;
        if ( value === null || value === undefined ) return value;
        return String( value ).replace( /^\s*(?:\+1)\s*[-.]?\s*/, '' );
      },
      getOATSEmail( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.contact_details?.email;
      },
      getOATSPager( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.contact_details?.phone_pager;
      },
      getOATSEthnicity( patientBundleOATS ) {
        const code = patientBundleOATS?.patient_profile?.ethnicity_code;
  
        const ethnicityMap = {
          1: 'African/Afro-Caribbean Origin',
          2: 'Asian',
          3: 'Caucasian',
          4: 'Indian Sub-Continent',
          5: 'Indigenous/Aboriginal',
          6: 'Latin American',
          7: 'Middle Eastern',
          8: 'Pacific Islander',
          9: 'Multiracial',
          10: 'Other',
          11: 'Unknown'
        };
  
        return ethnicityMap[code] ?? '';
      },
      getOATSEthnicityOther( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.ethnicity_other;
      },
      getOATSRHFactor( patientBundleOATS ) {
        const rhMap = {
          '+': 'positive',
          '-': 'Negative',
          '?': 'Unknown'
        };
  
        return rhMap [ patientBundleOATS?.diagnostics?.blood?.rh_indicator ] || 'Unknown';
      },
      getOATSBloodType( patientBundleOATS ) {
        return patientBundleOATS?.diagnostics?.blood?.type;
      },
      getOATSBloodTypeVerified( patientBundleOATS ) {
        return patientBundleOATS?.diagnostics?.blood?.type_verified ? 'Checked' : 'Unchecked' ;
      },
      getMobile( patient ) {
        let mobile = patient.telecom?.filter( ( n ) => ( n.use === 'mobile' ) ) ;
        if( mobile ) {
          const value = String( _.get( mobile[ 0 ], 'value', '' ) );
          return value.replace( /^\s*(?:\+1)\s*[-.]?\s*/, '' );
        } 
        return ' ';
        // return _.get( mobile[ 0 ], 'value', 'r' ); 
      },
      getHomeNumber( patient ) {
        let home = patient.telecom?.filter( ( n ) => ( n.use === 'home' ) ) ;
        if( home && home[0] && home[0].value ) {
          const value = String( home[0].value );
          return value.replace( /^\s*(?:\+1|1)\s*[-.]?\s*/, '' );
        }   
        return ' ';
      },
      getEmail( patient ) {
        let email = patient.telecom?.filter( ( n ) => ( n.system === 'email' ) ) ;
        if( email && email[0] && email[0].value ) {
          return email[0].value;
        }   
      },
      getPager( patient ) {
        let pager = patient.telecom?.filter( ( n ) => ( n.system === 'pager' ) ) ;
        if( pager && pager[0] && pager[0].value ) {
          return pager[0].value;
        }   
      },
      getEthnicity( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let ethnicity = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#262' ) ) ;
        if( ethnicity && ethnicity[ 0 ] ) {
          return _.get( ethnicity[0], 'resource.component[0].valueString', '' );
        } 
        }
      },
      getEthnicityOther( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let ethnicity = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#263' ) ) ;
        if( ethnicity && ethnicity[ 0 ] ) {
          return _.get( ethnicity[0], 'resource.component[0].valueString', '' );
        } 
        }
      },
      getIsGenderDifferent( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let genderDifferent = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#320' ) ) ;
        if( genderDifferent && genderDifferent[ 0 ] ) {
          return _.get( genderDifferent[ 0 ], 'resource.component[0].valueBoolean', 'Unchecked' ) === true ? 'true' : 'false';
        } 
        return 'false';
        }
      },
      getGenderDifferent( patient ) {
        let patientExtension = patient.extension ;
        if( patientExtension && patientExtension[ 0 ] ) {
          for( let item of patientExtension ) {
               if( item.url?.includes( "patient-genderIdentity" ) ) {
                return _.get( item, 'valueCodeableConcept.coding[0].code', '' );
               }
          
        }
        }
      },
      getGenderOther( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let genderOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#321' ) ) ;
        if( genderOther && genderOther[ 0 ] ) {
          return _.get( genderOther[0], 'resource.component[0].valueString' );
        } 
        }
      },
      getInsuranceType( patientBundle ) {
        let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return _.get( coverages[ 0 ][ 0 ], 'resource.contained[0].name' );
      }
      },
      getOATSInsuranceType( patientBundleOATS ) {
        const plan_code = patientBundleOATS?.patient_profile?.insurance?.plan_code;
        return plan_code === 1 ? 'OHIP' : plan_code === 2 ? 'OOP' : plan_code === 3 ? 'Private' : plan_code === 7 ? 'Other' : plan_code === 6 ? 'OOC' : '' ;
      },
      getInsuranceNumber( patientBundle ) {
        let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
        if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
          return _.get( coverages[ 0 ][ 0 ], 'resource.subscriberId' );
       }
      },
      getOatsInsuranceNumber( patientBundleOATS ) {
        const number = patientBundleOATS?.patient_profile?.insurance?.number;
        const other_plan = patientBundleOATS?.patient_profile?.insurance?.other_plan;
        return number ? number : other_plan ?? '';
      },
      getInsuranceProvince( patientBundle ) {
        let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
        if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
          if( this.getInsuranceType( patientBundle ) === 'OHIP' ){
            return 'n/a'
          }
          if( this.getInsuranceType( patientBundle ) === 'Private' ){
            return 'n/a'
          }
          if( this.getInsuranceType( patientBundle ) === 'OOC' ){
            return 'n/a'
          }
          if( this.getInsuranceType( patientBundle ) === 'Other' ){
            return 'n/a'
          }
          return _.get( coverages[ 0 ][ 0 ], 'resource.contained[0].contact[0].address.state' );
       }
       return 'n/a';
      },
      getOatsInsuranceProvince( patientBundleOATS ) {
        return patientBundleOATS?.patient_profile?.insurance?.other_province_plan ?? 'n/a';
      },
      getClassName( patientBundle ) {
        let coverages = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Coverage' && n[ 0 ].resource?.status === 'active' ) );
        if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
          return coverages[ 0 ][ 0 ].resource?.class[ 0 ]?.name;
        }
      },
      getBloodType( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let bloodType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#332' ) ) ;
        if( bloodType && bloodType[ 0 ] ) {
          return _.get( bloodType[0], 'resource.component[0].valueString' ); 
        } 
        }
      },
      getRHFactor( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let rhFactor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#333' ) ) ;
        if( rhFactor && rhFactor[ 0 ] ) {
          return _.get( rhFactor[0], 'resource.component[0].valueString' ); 
        } 
        }
      },
      getBloodTypeVerified( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
        let bloodTypeVerified = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#359' ) ) ;
        if( bloodTypeVerified && bloodTypeVerified[ 0 ] ) {
          return _.get( bloodTypeVerified[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ; 
        } 
        }
      },
      // getCPRA( patientBundle ) {
      //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
      //   if( observation && observation[ 0 ] ) {
      //   let cpra = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#135' ) ) ; 
      //   if( cpra && cpra[0 ]?.resource.code.text ) {
      //     return _.get( cpra[0], 'resource.component[0].valueString' );  
      //   }   
      // }
      // },
    },
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 750px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 2780px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    /* padding-top: 5px; */
    padding-bottom: 10px;
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  width: 200px;
  /* padding-left: 50px; */
  }
  
  .inputDisplayCovergage {
  border-style: solid;
  width: 320px;
  background-color: #F2F2F2;
  }
  
  .inputDisplayCustom {
  border-style: solid;
  width: 200px;
  border-color: rgb(185, 184, 234);
  background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  .highlightField :deep(.afflo-ds-form-control) {
    border: 2px solid red;
  }
  
  :deep( label) {
    width: max-content;
  }
  
  :deep(.mandatory-field label::after) {
    content: " *";
    color: red;
  }
  
  :deep(.CoverageClassName .afflo-ds-form-control) {
    width: 360px;
  }
  
  :deep(.Email .afflo-ds-form-control) {
    width: 280px;
  }
  
  
  </style>
  